<template>
	<v-tooltip
		:text="translateText(text)"
		:close-delay="closeDelay"
		:open-delay="openDelay"
	>
		<template v-if="$slots.activator" #activator="activatorProps">
			<div v-bind="activatorProps.props">
				<slot name="activator" v-bind="activatorProps"></slot>
			</div>
		</template>
		<template v-if="$slots.default" #default="defaultProps">
			<slot v-bind="{ text, ...defaultProps }"> </slot>
		</template>
	</v-tooltip>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

type ToolProps = {
	text: string
	openDelay?: number
	closeDelay?: number
}

defineProps<ToolProps>()
const { t, te } = useI18n()
const translateText = (text: string) => {
	if (!text) return ''
	return te(text) ? t(text) : text
}
</script>

<style></style>
